import { GetAllCoinType } from 'interfaces';

export const ConvertBoxCoinsListData: GetAllCoinType[] = [
    { symbol: 'USDT', name: 'تتر' },
    { symbol: 'TRX', name: 'ترون' },
    { symbol: 'IRT', name: 'تومان' },
    { symbol: 'BTC', name: 'بیت کوین' },
    { symbol: 'ETH', name: 'اتریوم' },
    { symbol: 'XRP', name: 'ریپل' },
    { symbol: 'LTC', name: 'لایت کوین' },
    { symbol: 'ADA', name: 'کاردانو' },
    { symbol: 'DOT', name: 'پولکادات' },
    { symbol: 'SOL', name: 'سولانا' },
    { symbol: 'BNB', name: 'بایننس کوین' },
    { symbol: 'DOGE', name: 'دوج کوین' },
    { symbol: 'MATIC', name: 'پالیگان' },
];
